import { CircularSpinner } from '@festina-life/ui/feedback'
import { useTranslateEnum } from '@festina-life/ui/hooks'
import { Suspense } from 'react'

import { Group } from './Group'
import { Option } from './Option'
import type {
  RankedItem,
  SearchableItemCategory,
  SearchableItemGroup,
} from './types'

type Props = {
  group: SearchableItemGroup
  items: SearchableItemCategory | RankedItem[]
}

export const CategoryOption = ({ group, items }: Props) => {
  const translateEnum = useTranslateEnum()

  return (
    <Group
      key={group}
      group={group}
      groupName={translateEnum('enum.SearchGroup', group)}
    >
      <Suspense fallback={<CircularSpinner className="m-2 size-8" />}>
        {Object.values(items)?.map((item) => (
          <Option key={item.title} value={item} group={group} />
        ))}
      </Suspense>
    </Group>
  )
}
